import { ErrorMessage } from "formik"
import React from "react"

const TextError = ({ name }) => {
  return (
    <ErrorMessage name={name} component="div" className="error text-danger" />
  )
}

export default TextError
